module.exports = __webpack_public_path__ + "static/media/samosa.0f1ba220.png";